import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Alert, Checkbox, Form } from "antd";
import { observer } from "mobx-react";
import { EAffiliateCurrency } from "@devowl-wp/api-real-commerce";
import { AFFILIATE_PROGRAM } from "./affiliateProgram.js";
import { useStores } from "../../../../../../store/stores.js";
import { __, _i } from "../../../../../../utils/i18n.js";
import { AffiliatePanel } from "../affiliatePanel.js";
const AffiliateTermsFields = observer(()=>{
    const { accountV2Store: { session } } = useStores();
    const isLoggedIn = !!session?.isLoggedIn;
    return /*#__PURE__*/ _jsxs(AffiliatePanel, {
        heading: __("Consents"),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-affiliate-note",
                children: [
                    /*#__PURE__*/ _jsx(InfoCircleOutlined, {}),
                    /*#__PURE__*/ _jsx("span", {
                        children: _i(__("By signing up, you agree to the {{a}}Affiliate Terms and Conditions of %s{{/a}}.", AFFILIATE_PROGRAM.name), {
                            a: /*#__PURE__*/ _jsx("a", {
                                href: AFFILIATE_PROGRAM.terms,
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        })
                    })
                ]
            }),
            !isLoggedIn && /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-affiliate-note",
                children: [
                    /*#__PURE__*/ _jsx(InfoCircleOutlined, {}),
                    /*#__PURE__*/ _jsx("span", {
                        children: _i(__("Information on the processing of your personal data can be found in our {{a}}privacy policy{{/a}}."), {
                            a: /*#__PURE__*/ _jsx("a", {
                                href: AFFILIATE_PROGRAM.privacy,
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: ({ affiliate: { paymentDetails: prevPd } }, { affiliate: { paymentDetails: nextPd } })=>prevPd?.currency !== nextPd?.currency,
                children: ({ getFieldValue })=>{
                    const currency = getFieldValue([
                        "affiliate",
                        "paymentDetails",
                        "currency"
                    ]);
                    return currency !== undefined && currency !== EAffiliateCurrency.EUR && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Alert, {
                                style: {
                                    marginTop: 15
                                },
                                message: _i(__("International transfers outside the SEPA area cause additional fees, which will be passed on to you. Your payout amount will be automatically reduced by the {{a}}fees of our money transfer service Wise{{/a}}."), {
                                    a: /*#__PURE__*/ _jsx("a", {
                                        href: `https://wise.com/gb/pricing/send-money?sourceAmount=500&sourceCcy=EUR&targetCcy=${currency}&tab=0`,
                                        rel: "noreferrer",
                                        target: "_blank"
                                    })
                                }),
                                type: "info",
                                showIcon: true
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(Form.Item, {
                                name: "feeAgreement",
                                valuePropName: "checked",
                                rules: [
                                    {
                                        type: "boolean",
                                        required: true,
                                        transform: (value)=>value || undefined,
                                        message: __("Please confirm the fee agreement!")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Checkbox, {
                                    children: __("I agree that fees for payout of my affiliate commissions may be deducted.")
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
});
export { AffiliateTermsFields };
